import { withWidth } from '@material-ui/core';
import { WithWidth } from '@material-ui/core/withWidth';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'recompose';

import { myFlipdish } from '../../../helpers/externalLinks';
import { getSelectedApp } from '../../../selectors/app.selector';
import LayoutWrapper, { LayoutContext } from './LayoutWrapper';
import WebsitePreview from './WebsitePreview';

const mapStateToProps = (state: AppState) => ({
  currentApp: getSelectedApp(state),
});

type Props = ReturnType<typeof mapStateToProps> & WithWidth & RouteComponentProps;

export default compose<any, Props>(
  withRouter,
  connect(mapStateToProps),
  withWidth()
)(function PreviewPage(props: Props) {
  const { currentApp, width, history } = props;
  const appId = currentApp.AppId;
  const url = myFlipdish(currentApp.panaceaVanityUrl);

  useEffect(
    () => {
      if (width !== 'xs' && width !== 'sm') {
        history.replace(`/${appId}/website/live-editor`);
      }
    },
    [width]
  );

  return (
    <LayoutWrapper
      title="Live_website_view"
      toParent={`/${appId}/website/live-editor`}
      fullWidth
      strictToParent
      withView
      documentTitle="Web_editor"
    >
      <LayoutContext.Consumer>
        {(view: any) => <WebsitePreview view={view} url={url} />}
      </LayoutContext.Consumer>
    </LayoutWrapper>
  );
});
